import React from 'react';
import BasicLabel from 'components/BasicLabel';
import BasicTextArea from 'components/BasicTextArea';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

const TextArea = props => {
  const {
    name,
    labelText,
    required,
    rows = 10,
    value,
    isValid,
    resize = false,
    placeholder = '0 characters of the 2000 character limit',
    onChange,
    onBlur,
  } = props;

  return (
    <div className="form__group form__group--compact">
      <BasicLabel
        name={name}
        required={required}
        text={labelText}
        styles={{
          fontWeight: 'bold',
        }}
      />
      <BasicTextArea
        name={name}
        content={value}
        isValid={isValid}
        placeholder={placeholder}
        controlFunc={onChange}
        touchFunc={onBlur}
        rows={rows}
        resize={resize}
      />

      <ErrorMessage
        name="Description"
        render={message => <div className="form__error">{message}</div>}
      />
    </div>
  );
};

TextArea.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  isValid: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  rows: PropTypes.number,
  resize: PropTypes.bool,
};

export default TextArea;
